import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import _foreach from 'lodash/forEach'

import DefaultLayout from '@/coreui/layouts/Default'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/adressen/uebersicht'
  },
  {
    path: '/security',
    name: 'Security',
    redirect: '/security/login',
    component: {
      render () {
        return h(resolveComponent('router-view'))
      }
    },
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/Login.vue')
      },
      {
        path: 'logout',
        name: 'Logout',
        component: () => import('@/views/Logout.vue')
      },
      {
        path: 'password',
        name: 'Password',
        component: () => import('@/views/Password.vue')
      }
    ]
  },
  {
    path: '/error',
    name: 'Error',
    redirect: '/error/403',
    component: {
      render () {
        return h(resolveComponent('router-view'))
      }
    },
    children: [
      {
        path: '403',
        name: 'Page403',
        component: () => import('@/views/Page403.vue')
      }
    ]
  },
  {
    path: '/profile',
    redirect: '/profile/password',
    name: 'Profil',
    component: DefaultLayout,
    children: [
      {
        path: 'password',
        name: 'Mein Passwort Ändern',
        component: () => import('@/views/Profile/Password'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_EDITOR'] }
      }
    ]
  },
  {
    path: '/benutzer',
    redirect: '/benutzer/uebersicht',
    name: 'Benutzer',
    component: DefaultLayout,
    children: [
      {
        path: 'uebersicht',
        name: 'Benutzerverwaltung - Übersicht',
        component: () => import('@/views/Benutzer/Index'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'neu',
        name: 'Benutzerverwaltung - Neuer Benutzer',
        component: () => import('@/views/Benutzer/Neu'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'passwort/:uuid',
        name: 'Benutzer Passwort ändern',
        component: () => import('@/views/Benutzer/Passwort'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'editieren/:uuid',
        name: 'Benutzer Editieren',
        component: () => import('@/views/Benutzer/Edit'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      }
    ]
  },
  {
    path: '/adressen',
    redirect: '/adressen/uebersicht',
    name: 'Adressen',
    component: DefaultLayout,
    children: [
      {
        path: 'uebersicht',
        name: 'Adressen - Übersicht',
        component: () => import('@/views/Adressen/IndexTest'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_EDITOR'] }
      },
      {
        path: 'deleted',
        name: 'Adressen - Deaktivierte',
        component: () => import('@/views/Adressen/Deleted'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_EDITOR'] }
      },
      {
        path: 'neu',
        name: 'Adressen - Neues Adresse',
        component: () => import('@/views/Adressen/Neu'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_EDITOR'] }
      },
      {
        path: 'editieren/:uuid',
        name: 'Adressen Editieren',
        component: () => import('@/views/Adressen/Edit'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_EDITOR'] }
      },
      {
        path: 'details/:uuid',
        name: 'Adressdetails',
        component: () => import('@/views/Adressen/Details'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_EDITOR'] }
      },
      {
        path: 'massenbearbeitung',
        name: 'Mehrere Adressen Editieren',
        component: () => import('@/views/Adressen/MassEdit'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_EDITOR'] }
      },
      {
        path: 'logs',
        name: 'Logs',
        component: () => import('@/views/Adressen/Logs'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_EDITOR'] }
      },
      {
        path: 'importieren',
        name: 'import',
        component: () => import('@/views/Adressen/Import'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_EDITOR'] }
      },
      {
        path: 'exportieren',
        name: 'export',
        component: () => import('@/views/Adressen/Export'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_EDITOR'] }
      }
    ]
  },
  {
    path: '/produkt',
    redirect: '/produkt/uebersicht',
    name: 'Produkte',
    component: DefaultLayout,
    children: [
      {
        path: 'uebersicht',
        name: 'Produkte - Übersicht',
        component: () => import('@/views/Produkt/Index'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'neu',
        name: 'Produkte - Neues Produkt',
        component: () => import('@/views/Produkt/Neu'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'editieren/:uuid',
        name: 'Produkte Editieren',
        component: () => import('@/views/Produkt/Edit'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      }
    ]
  },
  {
    path: '/konfiguration',
    redirect: '/konfiguration/uebersicht',
    name: 'Konfiguration',
    component: DefaultLayout,
    children: [
      {
        path: 'uebersicht',
        name: 'Konfiguration - Übersicht',
        component: () => import('@/views/Config/Index'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'neu',
        name: 'Konfiguration - Neue Konfiguration',
        component: () => import('@/views/Config/Neu'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'editieren/:id',
        name: 'Konfiguration Editieren',
        component: () => import('@/views/Config/Edit'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      }
    ]
  },
  {
    path: '/integration',
    redirect: '/integration/typo3',
    name: 'Integration',
    component: DefaultLayout,
    children: [
      {
        path: 'typo3',
        name: 'Integration - TYPO3',
        component: () => import('@/views/Integration/Index'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      }
    ]
  },
  {
    path: '/texte',
    redirect: '/texte/uebersicht',
    name: 'Texte',
    component: DefaultLayout,
    children: [
      {
        path: 'uebersicht',
        name: 'Texte - Übersicht',
        component: () => import('@/views/Text/Index'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'neu',
        name: 'Texte - Neuer Text',
        component: () => import('@/views/Text/Neu'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'editieren/:id',
        name: 'Texte Editieren',
        component: () => import('@/views/Text/Edit'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      }
    ]
  },
  {
    path: '/shop-links',
    redirect: '/shop-links/uebersicht',
    name: 'Bestellstrecken',
    component: DefaultLayout,
    children: [
      {
        path: 'uebersicht',
        name: 'Bestellstrecken - Übersicht',
        component: () => import('@/views/ShopLinks/Index'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'neu',
        name: 'Bestellstrecken - Neue Bestellstrecke',
        component: () => import('@/views/ShopLinks/Neu'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'editieren/:uuid',
        name: 'Bestellstrecke Editieren',
        component: () => import('@/views/ShopLinks/Edit'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      }
    ]
  },
  {
    path: '/kundengruppen',
    redirect: '/kundengruppen/uebersicht',
    name: 'Kundengruppen',
    component: DefaultLayout,
    children: [
      {
        path: 'uebersicht',
        name: 'Kundengruppen - Übersicht',
        component: () => import('@/views/Kundengruppe/Index'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'neu',
        name: 'Kundengruppen - Neue Kundengruppe',
        component: () => import('@/views/Kundengruppe/Neu'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      },
      {
        path: 'editieren/:uuid',
        name: 'Kundengruppen Editieren',
        component: () => import('@/views/Kundengruppe/Edit'),
        props: true,
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      }
    ]
  },
  {
    path: '/verfuegbarkeitscheck',
    redirect: '/verfuegbarkeitscheck/uebersicht',
    name: 'Verfuegbarkeitscheck',
    component: DefaultLayout,
    children: [
      {
        path: 'uebersicht',
        name: 'Verfuegbarkeitscheck - Übersicht',
        component: () => import('@/views/VerfuegbarkeitsCheck/Index'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_EDITOR'] }
      }
    ]
  },
  {
    path: '/verfuegbarkeitscheck/extern',
    name: 'Verfuegbarkeitscheckextern',
    component: () => import('@/views/VerfuegbarkeitsCheck/Extern')
  },
  {
    path: '/verfuegbarkeitscheck/externneu',
    name: 'Verfuegbarkeitscheckexternneu',
    component: () => import('@/views/VerfuegbarkeitsCheck/ExternNeu')
  },
  {
    path: '/verfuegbarkeitscheck/extern-transparent',
    name: 'Verfuegbarkeitscheckexterntransparent',
    component: () => import('@/views/VerfuegbarkeitsCheck/ExternTransparent')
  },
  {
    path: '/verfuegbarkeitscheck/iframe',
    name: 'Verfuegbarkeitscheckiframe',
    component: () => import('@/views/VerfuegbarkeitsCheck/Iframe')
  },
  {
    path: '/geoapi',
    redirect: '/geoapi/uebersicht',
    name: 'GeoApi',
    component: DefaultLayout,
    children: [
      {
        path: 'uebersicht',
        name: 'GeoAPi - Übersicht',
        component: () => import('@/views/GeoApi/Index'),
        meta: { requiresAuth: true, allowed: ['ROLE_ADMIN'] }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () { return { top: 0 } }
})

//   ____  _____ _____ ____  _     ___ _   _ _  __   ___  _   _ _   _ _____      _   _   _ _____ _   _
//  |  _ \| ____| ____|  _ \| |   |_ _| \ | | |/ /  / _ \| | | | \ | | ____|    / \ | | | |_   _| | | |
//  | | | |  _| |  _| | |_) | |    | ||  \| | ' /  | | | | |_| |  \| |  _|     / _ \| | | | | | | |_| |
//  | |_| | |___| |___|  __/| |___ | || |\  | . \  | |_| |  _  | |\  | |___   / ___ \ |_| | | | |  _  |
//  |____/|_____|_____|_|   |_____|___|_| \_|_|\_\  \___/|_| |_|_| \_|_____| /_/   \_\___/  |_| |_| |_|
//
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters['security/isAuthenticated']) {
      next()
    } else {
      next({ name: 'Login' })
    }
  } else {
    next()
  }
})
//   ____   ___  _     _____ ____
//  |  _ \ / _ \| |   | ____/ ___|
//  | |_) | | | | |   |  _| \___ \
//  |  _ <| |_| | |___| |___ ___) |
//  |_| \_\\___/|_____|_____|____/
//
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.allowed)) {
    if (store.getters['security/hasRole']('ROLE_ADMIN')) {
      next()
    } else {
      let hasRole = false
      _foreach(to.meta.allowed, function (role) {
        if (store.getters['security/hasRole'](role)) {
          hasRole = true
        }
      })
      if (!hasRole) {
        next({ name: 'Page403' })
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

//   ____   _    ____ _____   _____ ___ _____ _     _____ ____
//  |  _ \ / \  / ___| ____| |_   _|_ _|_   _| |   | ____/ ___|
//  | |_) / _ \| |  _|  _|     | |  | |  | | | |   |  _| \___ \
//  |  __/ ___ \ |_| | |___    | |  | |  | | | |___| |___ ___) |
//  |_| /_/   \_\____|_____|   |_| |___| |_| |_____|_____|____/
//
router.beforeEach((to, from, next) => {
  document.title = 'TKRZ - ' + to.name
  next()
})

export default router
